import { render } from "./iQuelaFooter.vue?vue&type=template&id=15b8fbc8&scoped=true"
import script from "./iQuelaFooter.vue?vue&type=script&lang=js"
export * from "./iQuelaFooter.vue?vue&type=script&lang=js"

import "./iQuelaFooter.vue?vue&type=style&index=0&id=15b8fbc8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\HP\\Desktop\\Proyectos Vue.js\\version-produccion-iquela\\Dashboard_usuarios\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b8fbc8"]])

export default __exports__